import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface LastMessage {
  sender: string
  content: string
  timestamp: number
}

interface MessagesState {
  unreadCounts: Record<string, number>
  lastReadTimestamps: Record<string, number>
  lastMessages: Record<string, LastMessage>
}

const initialState: MessagesState = {
  unreadCounts: {},
  lastReadTimestamps: {},
  lastMessages: {},
}

const messagesSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    setUnreadCount: (state, action: PayloadAction<{ conversationId: string; count: number }>) => {
      state.unreadCounts[action.payload.conversationId] = action.payload.count
    },
    incrementUnreadCount: (state, action: PayloadAction<string>) => {
      const currentCount = state.unreadCounts[action.payload] || 0
      state.unreadCounts[action.payload] = currentCount + 1
    },
    decrementUnreadCount: (state, action: PayloadAction<string>) => {
      const currentCount = state.unreadCounts[action.payload] || 0
      state.unreadCounts[action.payload] = Math.max(0, currentCount - 1)
    },
    updateLastReadTimestamp: (
      state,
      action: PayloadAction<{ conversationId: string; timestamp: number }>
    ) => {
      state.lastReadTimestamps[action.payload.conversationId] = action.payload.timestamp
    },
    setLastMessage: (
      state,
      action: PayloadAction<{ conversationId: string; message: LastMessage }>
    ) => {
      state.lastMessages[action.payload.conversationId] = action.payload.message
    },
  },
})

export const {
  setUnreadCount,
  incrementUnreadCount,
  decrementUnreadCount,
  updateLastReadTimestamp,
  setLastMessage,
} = messagesSlice.actions

export default messagesSlice.reducer
